import { render, staticRenderFns } from "./d-table.vue?vue&type=template&id=66a8ba79&"
import script from "./d-table.vue?vue&type=script&lang=js&"
export * from "./d-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports